import React, { useEffect, useState } from "react";
import styles from "./OverviewPage.module.scss";
import TotalLineChart from "../../../components/site/TotalSales/TotalSales";
import { useDispatch, useSelector } from "react-redux";
import OverviewItem from "../../../components/site/OverviewItem/OverviewItem";
import { Helmet } from "react-helmet";
import { userStatistics } from "../../../redux/actions/user/userStatistics";
import { userStatisticMonth } from "../../../redux/actions/user/userStatisticMonth";
import OverviewMonth from "../OverviewMonth/OverviewMonth";
import OverviewPartnerDashboard from "../../../components/site/OverviewPartnerDashboard/OverviewPartnerDashboard";
import { currencyFormat } from "../../../utils/currencyFormat";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Steps from "../../../components/site/Steps/Steps";
import StatisticsDisplay from "../../../components/site/StatisticsDisplay/StatisticsDisplay";
import axios from "axios";

const OverviewPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userStatistics());
  }, []);

  const {
    userProfile: { data: userProfile = {} },
    userStatistics: {
      data: dataUserStatistics = {},
      loading: loadingUserStatistics,
    },
  } = useSelector((state) => state.user);

  const [extensionData, setExtensionData] = useState(null);
  const [telegramData, setTelegramData] = useState(null);
  const [totalEarningsSum, setTotalEarningsSum] = useState(0);
  const [totalRefSum, setTotalRefSum] = useState(0);

  // Statistics variables
  const [statistics, setStatistics] = useState({
    total_gmv: 2702305608534,
    gmv_per_product: 182523,
    total_products: 14805226,
    total_sells: 173932579,
    top_brands: ["Apple", "Samsung", "Xiaomi"],
    top_categories: ["Смартфоны", "Телефоны и гаджеты", "Бытовая техника"],
  });

  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Главная</title>
      </Helmet>

      <div className="crm demo6 mb-25">
        {/* <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-main">
                <h4 className="text-capitalize breadcrumb-title">
                  Пошаговая инструкция
                </h4>
              </div>
            </div>
            <Steps />
          </div>
        </div> */}
        <div className="crm demo6 mb-25">
          <div className="container-fluid">
            {/* Video Section */}
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-main">
                  <h4 className="breadcrumb-title">Видео инструкция</h4>
                </div>
                <div className="checkout wizard7 global-shadow border-0 px-sm-50 px-20 pt-sm-50 py-30 mb-30 bg-white radius-xl w-100">
                  <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, maxWidth: "800px", margin: "0 auto", borderRadius: "8px", overflow: "hidden" }}>
                    <iframe
                      src="https://www.youtube.com/embed/xbBE0yOeMzg?start=9"
                      title="Видео инструкция"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    />
                  </div>
                </div>

                {/* Statistics Section */}
                <div className="breadcrumb-main mt-4">
                  <h4 className="breadcrumb-title">Статистика продаж</h4>
                </div>
                <div className="checkout wizard7 global-shadow border-0 px-sm-50 px-20 pt-sm-50 py-30 mb-30 bg-white radius-xl w-100">
                  <StatisticsDisplay statistics={statistics} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OverviewPage;
